import { BaseApiClient } from '@/services/baseApiClient';
import type { RequestOptions } from '@/utils/request';
import type {
  CreateEmissionFactorValidityArg,
  DeleteEmissionFactorValidityArg,
  GetEmissionFactorValiditiesArg,
  GetEmissionFactorValidityArg,
  UpdateEmissionFactorValidityArg,
  CreateEmissionFactorValidityResult,
  DeleteEmissionFactorValidityResult,
  GetEmissionFactorValiditiesResult,
  GetEmissionFactorValidityResult,
  UpdateEmissionFactorValidityResult,
} from './types';

import type { IEmissionFactorValiditiesApiClient } from './types/interface';

export class EmissionFactorValiditiesApiClient extends BaseApiClient implements IEmissionFactorValiditiesApiClient {
  constructor() {
    super('api/emission-factors');
  }

  public getOne(
    { factorId, validityId }: GetEmissionFactorValidityArg,
    signal: RequestOptions['signal'],
  ): Promise<GetEmissionFactorValidityResult> {
    return this.http.get(`${factorId}/validities/${validityId}`, { signal });
  }

  public get(
    factorId: GetEmissionFactorValiditiesArg,
    signal: RequestOptions['signal'],
  ): Promise<GetEmissionFactorValiditiesResult> {
    return this.http.get(`${factorId}/validities`, { signal });
  }

  public create({
    factorId,
    validityPayload,
  }: CreateEmissionFactorValidityArg): Promise<CreateEmissionFactorValidityResult> {
    return this.http.post(`${factorId}/validities`, validityPayload);
  }

  public delete({
    factorId,
    validityId,
  }: DeleteEmissionFactorValidityArg): Promise<DeleteEmissionFactorValidityResult> {
    return this.http.delete(`${factorId}/validities/${validityId}`);
  }

  public update({
    factorId,
    validityId,
    payload,
  }: UpdateEmissionFactorValidityArg): Promise<UpdateEmissionFactorValidityResult> {
    return this.http.patch(`${factorId}/validities/${validityId}`, payload);
  }
}
